<template>
  <v-layout column fill-height v-cloak class="summary">
    <v-flex class="flex-column">
      <v-card-title class="px-0 flex-column__row">
        <h3
          class="subheading font-weight-bold secondary--text mb-1"
        >{{ document.name }} | {{ document.ordered_at | moment("MMM D YYYY") }}</h3>
        <v-spacer></v-spacer>
        <proposal-actions :document="document"></proposal-actions>
      </v-card-title>

      <v-layout row class="flex-column__row--full">
        <v-flex sm12 class="flex-column">
          <v-card class="fill-height scroll-card">
            <v-layout :fill-height="fillHeight" wrap>
              <v-flex fill-height class="flex-column summary__left">
                <v-card-title class="pt-0 flex-column__row">
                  <h3
                    class="subheading font-weight-bold secondary--text"
                  >Quote #{{ document.number }}</h3>
                </v-card-title>
                <v-layout
                  fill-height
                  class="mt-0 flex-column__row flex-column__row--full summary__inner"
                >
                  <v-flex class="py-0 summary__actions">
                    <proposal-actions :document="document" :list="true"></proposal-actions>
                  </v-flex>
                  <v-flex class="py-0 summary__quote">
                    <div class="quote-builder__card-inner inner-scroll">
                      <v-card-text
                        class="pa-0 inner-scroll__scroller proposal-border proposal-border--no-mar"
                      >
                        <v-card class="scroll-card fill-height" color="lightbg" flat>
                          <v-card-text class="py-0">
                            <proposal-header :document="document"></proposal-header>
                          </v-card-text>

                          <v-card-text class="pb-0">
                            <proposal-table :document="document"></proposal-table>
                          </v-card-text>

                          <v-divider class="ma-3" v-if="document.messages"></v-divider>

                          <v-card-text class="py-0" v-if="document.messages ">
                            <div class="preview-proposal__messages">
                              <h4 class="body-1 font-weight-bold">Notes:</h4>
                              <p>{{document.messages}}</p>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-card-text>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex class="summary__right">
                <div class="quote-builder__card-inner inner-scroll">
                  <v-card-title class="pt-0">
                    <h3 class="subheading font-weight-bold secondary--text">Order</h3>
                  </v-card-title>

                  <v-card-text class="py-0 inner-scroll__scroller">
                    <p v-if="po_number">
                      <strong>Purchase Order #</strong>
                      <br />
                      <span>{{ po_number }}</span>
                    </p>
                    <p v-if="sap_quotation_number">
                      <strong>SAP Quotation #</strong>
                      <br />
                      <span>{{ sap_quotation_number }}</span>
                    </p>
                    <p v-if="notes">
                      <strong>Shipping or Special Instructions</strong>
                      <br />
                      <span>{{ notes }}</span>
                    </p>
                  </v-card-text>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ProposalHeader from "@components/partials/ProposalHeader";
import ProposalTable from "@components/partials/ProposalTable";
import ProposalActions from "@components/partials/ProposalActions";
import ProposalNotesMessages from "@components/partials/ProposalNotesMessages";
var { mainRoutes } = require("@root/mixins");

export default {
  mixins: [mainRoutes],

  data() {
    return {
      po_number: "",
      notes: "",
      sap_quotation_number:"",
      disabled: false,
      loading: false
    };
  },

  components: {
    ProposalActions,
    ProposalTable,
    ProposalNotesMessages,
    ProposalHeader
  },

  computed: {
    ...mapGetters(["privacy"])
  },

  methods: {
    ...mapActions("documents", {
      ORDER_DOCUMENT: "orderDocument",
      UPDATE_DOCUMENT_FIELD: "updateDocumentField"
    }),

    save(field, value) {
      if (this.document.ordered_at) {
        return;
      }

      if (value != this.document[field]) {
        let params = {};
        params[field] = value;

        return this.UPDATE_DOCUMENT_FIELD({
          document_number: this.number,
          field,
          params
        });
      }
    },

    orderNow() {
      this.loading = true;
      this.$swal({
        title: "Are you sure?",
        text: "This cannot be undone.",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Order Now"
      }).then(result => {
        if (result.value) {
          this.ORDER_DOCUMENT({
            document: this.document
          }).then(data => {
            this.UPDATE_DOCUMENT_FIELDS({
              documnet_number: data.document.number,
              ordered_at: data.document.ordered_at
            });

            this.$swal({
              title: "Order Sent",
              text:
                "Thank you for your order, some one will be in contact with you shortly.",
              type: "success",
              showCancelButton: false,
              confirmButtonText: "Okay"
            }).then(result => {
              this.nextStep(6);
            });
          });
        } else {
          this.loading = false;

          return;
        }
      });
      return;
    }
  },

  created() {
    this.sap_quotation_number=this.document.sap_quotation_number;
    this.notes = this.document.notes;
    this.po_number = this.document.po_number;
  }
};
</script>
